import * as React from 'react';
import { PickerBox } from '@/pages/components/picker';
const Toast = require('react-toast-mobile');

import config from '@/server/config';
import request from '@/server/request';
import store from '@/redux/index';
import { types } from '@/redux/ui/confirm';
import * as ExpertEditReducer from '@/redux/pages/expert-edit';

export default class ExpertHome extends React.Component<any, any> {
    private loadTimer: any;
    constructor(props: any) {
        super(props);
        this.state = {
            index: 2, // 索引
            filterValue: '',
            filterData: [{
                name: '全部',
                value: '',
            }, {
                name: '待审核',
                value: 0,
            }, {
                name: '已通过',
                value: 1,
            }, {
                name: '暂存',
                value: 2,
            }, {
                name: '无效',
                value: -1,
            }], // 筛选内容
            expert: {}, // 专家信息
            expertCmsInteractRanking: {}, // 专家其他信息
            articleList: [], // 文章列表
            articlePage: 1, // 文章页码
            articleLoading: true, // 是否加载中
            articleLoadOver: false, // 是否加载完
        };
    }
    public render() {
        const state = this.state;
        const expert = state.expert;
        const expertCmsInteractRanking = state.expertCmsInteractRanking;
        return (
            <section className="expert-home">
                <div className="expert-data">
                    <div className="expert-datatop">
                        <div className="expert-headicon">
                            <img src={`${config.API}image/download/picture?imgId=${expert.logo}`} alt="" />
                        </div>
                        <div className="expert-user">
                            <div className="expert-user-main">
                                <strong>
                                {expert.fullname}
                                {
                                    expert.innovateFlag === 1 ?
                                    <img className="expert-level-icon" src={require('../../../assets/images/expert-level-icon.png')} title="创新工程师" /> : null
                                }
                                </strong>
                                <div className="expert-review">
                                    <img src={require('../../../assets/images/icon-expert-star.png')} alt="" />
                                    {expertCmsInteractRanking.allAvgScore || 0}分
                                <img src={require('../../../assets/images/icon-good.png')} alt="" />
                                    {expertCmsInteractRanking.allPraise || 0}
                            </div>
                            </div>
                            <p className="expert-user-intro">
                                <img src={require('../../../assets/images/icon-expert-bag.png')} alt="" />
                                {expert.job}
                        </p>
                            <p className="expert-user-intro">
                                <img src={require('../../../assets/images/icon-expert-floor.png')} alt="" />
                                {expert.expertCompany}
                        </p>
                            <p className="expert-user-intro">
                                <img src={require('../../../assets/images/icon-expert-label.png')} alt="" />
        在专家口碑排行第<span>{expertCmsInteractRanking.ranking || 0}</span>名
                        </p>
                        </div>
                    </div>
                    <div className="expert-databottom">
                        <div className="expert-user-btns">
                            <a href={`${config.WAPAPI}expert`}>
                                <img src={require('../../../assets/images/icon-expert.png')} alt="" /> 进入专家库
                            </a>
                            <a href={`${config.WAPAPI}expert/${expert.id}`}>
                                <img src={require('../../../assets/images/icon-home.png')} alt="" /> 我的主页
                            </a>
                            <span onClick={() => this.navigateToEdit()}>
                                <img src={require('../../../assets/images/icon-edit.png')} alt="" /> 编辑信息
                            </span>
                        </div>
                    </div>
                </div>
                <div className="expert-filter">
                    {/* <span className={`expert-filter-new ${state.index === 0 ? 'active' : null}`} onClick={() => this.tabAction(0)}>最新<i></i></span>
                    <span className={`expert-filter-hot ${state.index === 1 ? 'active' : null}`} onClick={() => this.tabAction(1)}>最热<i></i></span> */}
                    <span className={`expert-filter-btn ${state.index === 2 ? 'active' : null}`} onClick={() => this.tabAction(2)}>筛选<i></i></span>
                    <span></span>
                    <span></span>
                </div>
                <div className="expert-list">
                    {
                        state.articleList.map((v: any, k: number) => { 
                            return (
                                <div className="expert-item" key={v.id}>
                                    <a className="expert-item-body" href={`${config.WAPAPI}expert/article/${v.id}`}>
                                        <img src={v.picUrl} alt="" />
                                    <div className="expert-item-info">
                                            <strong>{v.articleName}</strong>
                                            <p>{v.articleSummary}</p>
                                        <div className="expert-func">
                                                <span className="expert-item-star">{v.avgScore}分</span>
                                                <span className="expert-item-good">{v.totalPraise}</span>
                                        </div>
                                    </div>
                                </a>
                                <div className="expert-item-footer">
                                    <div className="expert-item-fl">
                                            <span className={v.auditStatus === 1 ? '' : 'disabled'}>{v.auditStatusValue}</span>
                                    </div>
                                        <div className="expert-item-fr">
                                            {
                                                v.auditStatus === -1 && v.source === '2' ? 
                                                    <span onClick={() => this.viewReason(v.reason)}>查看理由</span> : null
                                            }
                                            {
                                                v.source === '1' || v.auditStatus === 1 ?
                                                    <span onClick={() => this.setOpenness(v.id, v.checkstate, k)}>{v.checkstate === '1' ? '下架' : '上架'}</span> : null
                                            }
                                            {
                                                v.source === '1' || v.auditStatus === 1 ?
                                                    <span className="blue" onClick={() => this.setTop(v.id, v.recommend)}>{v.recommend === 0 ? '置顶' : '取消置顶'}</span> : null
                                            }
                                            {
                                                (v.auditStatus === -1 || v.auditStatus === 1 || v.auditStatus === 2) && v.source === '2' ?
                                                    <span className="red" onClick={() => this.articleDelete(v.id, k)}>删除</span> : null
                                            }
                                    </div>
                                </div>
                            </div>
                            )
                        })
                    }
                </div>
                <p className="loading-tips">{state.articleLoadOver ? '没有更多数据' : '数据加载中...'}</p>
            </section>
        )
    }
    public componentDidMount() {
        this.getData();
        this.getAtricle();
        window.addEventListener('scroll', this.scrollAction.bind(this));
    }
    public componentWillUnmount() {
        window.removeEventListener('scroll', this.scrollAction.bind(this));
        if (this.loadTimer) { 
            clearTimeout(this.loadTimer);
        }
        // 卸载异步操作设置状态
        this.setState = (state, callback) => {
            return;
        }
    }
    
    // 加载页面数据
    private async getData() { 
        const r = await request({
            url: `${config.API}member/expert/details`
        });
        if (r.code === -1 && r.message === 'error-logon') {
            return this.props.history.push('/login');
        }
        if (r.code === 1) { 
            // 如果未认证专家，跳转到认证首页
            if (!r.obj.expert.id) { 
                this.props.history.push('/expert');
            }
            this.setState({
                expert: r.obj.expert,
                expertCmsInteractRanking: r.obj.expertCmsInteractRanking
            });
        }
    }

    // 加载文章数据
    private async getAtricle() { 
        const r = await request({
            url: `${config.API}member/article/list`,
            data: {
                auditStatus: this.state.filterValue,
                pageSize: 10,
                pageNum: this.state.articlePage
            }
        });
        if (r.code === 1) { 
            this.setState({
                articleList: [...this.state.articleList, ...r.obj.list],
                articleLoading: false,
                articleLoadOver: r.obj.pageNum >= r.obj.pages
            });
        }
    }

    /**
     * 加载更多
     * 滚动加载更多数据
     */
    private scrollAction() {
        if (this.state.articleLoading || this.state.articleLoadOver) { 
            return;
        }
        
        if (window.pageYOffset + window.innerHeight + 50 > document.body.scrollHeight) {
            if (this.loadTimer) { 
                clearTimeout(this.loadTimer);
            }
            this.loadTimer = setTimeout(() => {
                this.loadMoreArticle();
             }, 500);
        }
    }
    /**
     * 切换
     * @param tabIndex {number} 索引
     */
    private tabAction(tabIndex: number) {
        this.setState({
            index: tabIndex
        });
        if (tabIndex === 2) {
            // 显示弹框
            (PickerBox as any).open({
                data: [{
                    displayValue(item: any) {
                        return item.name;
                    },
                    list: this.state.filterData,
                }],
                // 成功回调
                onConfrim: (data: any) => {
                    this.setState({
                        filterValue: data.value
                    }, () => { 
                            this.reload();
                    });
                }
            });
        }
    }

    /**
     * 查看拒绝原因
     * @param reason {string} 原因
     */
    private viewReason(reason: string) { 
        store.dispatch({
            type: types.CONFIRM_SHOW,
            data: {
                text: reason,
                type: 1
            }
        });
    }
 
    /**
     * 删除文章
     * @param id {number} 文章id
     * @param k {number} 文章索引
     */
    private articleDelete(id: number, k: number) { 
        store.dispatch({
            type: types.CONFIRM_SHOW,
            data: {
                text: '是否确定删除文章?',
                onConfirm: async () => { 
                    const r = await request({
                        url: `${config.API}member/article/delete?id=${id}`
                    });
                    if (r.code === 1) { 
                        const temp = this.state.articleList;
                        temp.splice(k, 1);
                        this.setState({
                            articleList: temp
                        }, () => { 
                                if (this.state.articleList.length < 5) { 
                                    if (this.state.articleLoading || this.state.articleLoadOver) { 
                                        return;
                                    }
                                    this.loadMoreArticle();
                                }
                        });
                    }
                }
            }
        });
    }

    // 加载更多文章内容
    private loadMoreArticle() { 
        this.setState({
            articleLoading: true,
            articlePage: this.state.articlePage + 1
        }, () => { 
                this.getAtricle();
        });
    }

    /**
     * 置顶&取消置顶
     * @param {number} id 文章id
     * @param {number} isTop 是否置顶
     */
    private async setTop(id: number, isTop: number) {
        const r = await request({
            url: `${config.API}member/article/recommend?id=${id}&receptionRecommend=${isTop === 0 ? 1 : 0}`
        });
        if(r.code === 1) {
            this.reload();
        } else {
            Toast.T.notify(r.message);
        }
    }

    // 重新加载页面数据
    private reload() { 
        this.setState({
            articleList: [],
            articlePage: 1,
            articleLoading: true,
            articleLoadOver: false
        }, () => { 
                this.getAtricle();
        });
    }

    /**
     * 上架&下架
     * @param {number} id 文章id
     * @param {number} checkstate 已经上架&已经下架
     */
    private async setOpenness(id: number, checkstate: string, k: number) {
        const r = await request({
            url: `${config.API}member/article/checkstate`,
            method: 'post',
            data: {
                id,
                checkstate: checkstate === '1' ? 0 : 1
            }
        });
        
        if(r.code === 1) {
            const temp = this.state.articleList;
            temp[k].checkstate = checkstate === '1' ? '0' : '1';
            this.setState({
                articleList: temp
            });
        } else {
            Toast.T.notify(r.message);
        }
    }
    // 跳转编辑
    private async navigateToEdit() { 
        store.dispatch({
            type: ExpertEditReducer.types.INIT,
            initData: this.state.expert
        });
        this.props.history.push(`/expert/edit?id=${this.state.expert.id}&edit=1`);
    }
}